import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { ContractDetailsPageInitialData } from "./contractDetailsPageInitialData";

export const contractDetailsPageQueryOptions = (
  contractCode: string,
  materialNumber: string,
  packCode: string,
  contractPosition: string,
) =>
  queryOptions({
    queryKey: pageDataKeys.contractDetails(contractCode, materialNumber, packCode, contractPosition),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<ContractDetailsPageInitialData>>(
        `/page-data/my-account/contractDetails/${contractCode}/${materialNumber}/${packCode}/${contractPosition}`,
      ),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
